export default "__VITE_ASSET__XaKrsSm1__"